import React from 'react';
import { FaGooglePlay } from 'react-icons/fa';

const CTA = () => {
  return (
    <section id="download" className="section" style={{ paddingBlock: 88 }}>
      <div className="container">
        <div
          className="card"
          style={{
            borderRadius: '32px',
            padding: 32,
            background:
              'linear-gradient(135deg, rgba(255,122,61,.12), rgba(0,212,166,.10))',
            border: '1px solid var(--glass-bd)',
            textAlign: 'center',
          }}
        >
          <h3 className="title" style={{ fontSize: 34, marginBottom: 8 }}>
            Download Mealzy Foods Today
          </h3>
          <p className="subtitle" style={{ marginBottom: 22 }}>
            No more waiting or grocery trips. Craving a dosa, hearty lunch, or
            farm‑fresh vegetables? We'll bring it fresh.
          </p>
          <a
            className="btn btn-primary"
            href="https://play.google.com/store/apps/details?id=com.prashantsableannapurnadosaj.app&hl=en"
            target="_blank"
            rel="noreferrer"
          >
            <FaGooglePlay /> Get on Google Play
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
